import React from "react";

const Button = ({
  label,
  onClick,
  disabled,
  variant,
  withIcon,
  fullWidth,
  startIcon,
  size,
  justifyBetween = false,
}) => {
  let buttonColor;

  if (!disabled) {
    if (variant === "gradient") {
      buttonColor =
        "bg-gradient-to-br from-blue-600 via-purple-600 to-soft-red-600 text-monochrome-0";
    } else if (variant === "primary") {
      buttonColor =
        "bg-gradient-to-br from-blue-600 to-blue-500 text-monochrome-0";
    } else if (variant === "gradient-secondary") {
      buttonColor =
        "bg-gradient-to-br from-blue-50 via-purple-50 to-soft-red-50 text-monochrome-600";
    } else {
      buttonColor = "border-monochrome-100 bg-white text-monochrome-600";
    }
  } else {
    buttonColor = "border-monochrome-100 bg-white text-monochrome-600";
  }

  return (
    <button
      className={`${fullWidth && "w-full"} ${buttonColor} flex items-center ${justifyBetween ? "justify-between" : "justify-center"} gap-2 rounded-lg border ${size === "sm" ? "px-3 py-2 text-xs" : "px-4 py-2"} font-medium  transition-colors disabled:bg-monochrome-50 disabled:text-monochrome-300`}
      onClick={onClick}
      disabled={disabled}
    >
      {startIcon && startIcon}
      {variant === "gradient-secondary" ? (
        <span className="bg-gradient-to-br from-blue-600 via-purple-600 to-soft-red-600 bg-clip-text text-monochrome-0 text-transparent">
          {label}
        </span>
      ) : (
        label
      )}
      {withIcon && !disabled && withIcon}
    </button>
  );
};

export default Button;
